import React from "react";
import "./NavigationBar.scss";
const NavigationBar = () => {
  return (
    <section className="navigation">
      <input type="checkbox" className="navigation-checkbox" id="navi-toggle" />
      <label htmlFor="navi-toggle" className="navigation-button">
        <span className="navigation-icon">&nbsp;</span>
      </label>
      <div className="navigation-background">&nbsp;</div>
      <nav className="navigation-nav">
        <ul className="navigation-list">
          <li className="navigation-item">
            <a
              href="https://www.linkedin.com/in/amir-reza-tamandani"
              className="navigation-link"
            >
              linkedin
            </a>
          </li>
          <li className="navigation-item">
            <a
              href="https://gitlab.com/AmirRezaTamanadani"
              className="navigation-link"
            >
              gitlab
            </a>
          </li>
          <li className="navigation-item">
            <a href="https://github.com/AmirTaman" className="navigation-link">
              github
            </a>
          </li>
          <li className="navigation-item">
            <a href="https://t.me/azmonios" className="navigation-link">
              telegram
            </a>
          </li>
        </ul>
      </nav>
    </section>
  );
};

export default NavigationBar;
